import { Injectable } from '@angular/core';
import { startCase } from 'lodash';
import { DRAWER_IDS } from '../../../../../core/constants/drawer-ids.constant';
import { DrawerService } from '../../../../../core/services/drawer.service';
import { InsightMode } from '../../../insights.enums';
import {
  BIP,
  CaseDetailModel,
  ViewBipCaseDrawerParams,
} from '../../../insights.interface';
import { ViewBipCaseComponent } from '../view-bip-case.component';

@Injectable({
  providedIn: 'root',
})
export class ViewBipDrawerNavigationService {
  constructor(private readonly drawerService: DrawerService) {}

  openFromCaseDetail(
    caseDetail: CaseDetailModel | null | undefined,
    drawerIdsToClose: string[] = [],
    openDefineBehaviorOnLoad = false
  ): void {
    if (!caseDetail) {
      return;
    }

    const payload = this.buildBipPayload(caseDetail);
    this.open(payload, drawerIdsToClose, openDefineBehaviorOnLoad);
  }

  open(
    payload: BIP,
    drawerIdsToClose: string[] = [],
    openDefineBehaviorOnLoad = false
  ): void {
    drawerIdsToClose.forEach(drawerId => {
      this.drawerService.closeDrawer(drawerId);
    });

    const drawerParams: ViewBipCaseDrawerParams = {
      case: payload,
      mode: InsightMode.VIEW,
      openDefineBehaviorOnLoad,
    };

    const detailDrawerTitle = `${payload.studentName}’s Plan`;
    const existingDetailDrawerRef = this.drawerService.getDrawerRef(
      DRAWER_IDS.BIP_DETAIL
    );

    if (existingDetailDrawerRef) {
      this.drawerService.updateDrawerTitle(
        DRAWER_IDS.BIP_DETAIL,
        detailDrawerTitle
      );
      this.drawerService.setParams(DRAWER_IDS.BIP_DETAIL, drawerParams);
      return;
    }

    this.drawerService.closeDrawer(DRAWER_IDS.BIP_DETAIL);

    this.drawerService.openDrawer(
      ViewBipCaseComponent,
      detailDrawerTitle,
      1170,
      true,
      undefined,
      drawerParams,
      DRAWER_IDS.BIP_DETAIL
    );
  }

  private buildBipPayload(caseDetail: CaseDetailModel): BIP {
    const firstName = startCase(caseDetail.student?.firstName || '');
    const lastName = startCase(caseDetail.student?.lastName || '');

    return {
      studentId: caseDetail.studentId ?? 0,
      studentName: `${firstName} ${lastName}`.trim(),
      caseId: caseDetail.id ?? 0,
      caseOwnerName: caseDetail.caseOwnerName || '',
      behaviorCount: caseDetail.caseBehaviors?.length || 0,
      draftCount:
        caseDetail.caseBehaviors?.filter(behavior => behavior.draft).length ||
        0,
      caseMembers: [],
      lastModified: new Date().toISOString(),
      organizationName: caseDetail.student?.organizationName || '',
      organizationId: caseDetail.student?.organizationId,
      enrollId: caseDetail.student?.enrollId || '',
      caseOwnerId: caseDetail.caseOwnerId,
    };
  }
}
